<template>
  <div class="fixed top-0 h-0 z-10 w-full">
    <div
      class="px-4 py-2 duration-500 z-10 flex absolute top-0 w-full"
      :class="
        isFarEnough || stuck
          ? ' bg-white shadow-md text-secondary'
          : 'text-secondary bg-gradient-to-b from-primary to-transparent'
      "
    >
      <h1 class="w-full">
        <span class="text-2xl font-bold"> {{ appTitle }} </span>
        <span class="text-lg mr-2" v-if="title">/ {{ title }}</span>
        <span class="opacity-50">v 1.0.4.<router-link to="/dashboard/dev">rc </router-link> </span>
      </h1>
      <div>
        <v-icon icon="material-symbols:signal-disconnected" class="text-3xl hidden" />
        <!-- <v-icon v-if="online" icon="material-symbols:notifications" class="text-3xl" />
        <v-icon v-else icon="material-symbols:signal-disconnected" class="text-3xl" /> -->
      </div>
    </div>
  </div>
</template>

<script>
  import { useWindowScroll } from "@vueuse/core";
  import { RouterLink } from "vue-router";
  import { online } from "@/states/local";
  export default {
    name: "NavigationBarComp",
    data() {
      return {
        online,
        scroll: useWindowScroll(),
        appTitle: process.env.VUE_APP_TITLE || "App"
      };
    },
    props: {
      title: {
        type: String,
        default: ""
      },
      stuck: {
        type: Boolean,
        default: false
      }
    },
    components: {
      RouterLink
    },
    computed: {
      isFarEnough() {
        return this.scroll.y > 24;
      }
    }
  };
</script>
